<!--
<event-button color="success" :event="save">Opslaan</event-button>
-->
<template>
    <v-btn :color="color" @click="doEvent" v-bind="$props" :loading="loading">
        <slot></slot>
    </v-btn>
</template>

<script>
    import PropsMixin from "@/components/General/Button/Mixin/PropsMixin";

    export default {
        mixins: [PropsMixin],
        props: {
            event: {
                required: true,
            },
            confirmMessage: {
                required: false,
                type: String,
                default: null,
            },
            confirmTitle: {
                required: false,
                type: String,
                default: 'Bevestiging',
            },
            color: {
                required: false,
                default: 'primary',
            },
        },
        data() {
            return {
                loading: false,
            }
        },
        methods: {
            async doEvent() {
                if (this.confirmMessage) {
                    let res = await this.$dialog.confirm({
                        text: this.confirmMessage,
                        title: this.confirmTitle,
                    });
                    if (res) {
                        await this.run();
                    }
                } else {
                    await this.run();
                }
            },
            async run() {
                this.loading = true;
                this.error = false;
                return Promise.resolve(this.event()).finally(() => {
                    this.loading = false;
                });
            }
        }
    }
</script>
